import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { compose } from 'redux';
import CloudDownload from '@mui/icons-material/CloudDownload';
import WrappedFakeText from 'components/common/WrappedFakeText';
import { Button, Dialog, IconButton } from '@totalsoft/rocket-ui';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

export const OfferReportsListComponent = ({ t, reports, onCloseReportsModal, onReportDownload }) => (
  <Dialog
    open={true}
    onClose={onCloseReportsModal}
    aria-labelledby='reports-dialog-title'
    maxWidth='xs'
    fullWidth
    title={t('OfferAction.Reports')}
    content={
      reports == null || !reports.isLoaded ? (
        <WrappedFakeText lines={5} />
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('Reports.ReportName')}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reports.map((report, idx) => {
                  return (
                    <TableRow key={report.reportId}>
                      <TableCell>{report.reportName}</TableCell>
                      <TableCell align={'right'}>
                        <IconButton
                          id={'offerReports_' + idx + '_downloadBtn'}
                          color='primary'
                          variante='text'
                          size='small'
                          tooltip={t('Tooltips.Download')}
                          onClick={onReportDownload(report)}
                        >
                          <CloudDownload />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      )
    }
    actions={
      <BoxActionsWrapper forDialog>
        <Button id={'offerReports_closeBtn'} onClick={onCloseReportsModal} color='primary'>
          {t('Close')}
        </Button>
      </BoxActionsWrapper>
    }
  />
);

OfferReportsListComponent.propTypes = {
  t: PropTypes.func.isRequired,
  reports: PropTypes.array,
  onCloseReportsModal: PropTypes.func.isRequired,
  onReportDownload: PropTypes.func.isRequired
};

export default compose(withTranslation())(OfferReportsListComponent);
